import debounced from 'utils/debounced';

export const handlePrint = () => {
  window?.print();
};

export const scrollToTopOfPage = e => {
  e.preventDefault();
  window?.scrollTo({top: 0, behavior: 'smooth'});
};

export const scrollableDropdownMob = (dropdownRef, setIsDropdownFixed) => {
  const onWindowScroll = () => {
    const top = dropdownRef.current ? dropdownRef.current.offsetTop : 0;

    setIsDropdownFixed(window.scrollY > top);
  };

  const onWindowScrollDebounced = debounced(10, onWindowScroll);

  window.addEventListener('scroll', onWindowScrollDebounced, {passive: true});

  return () => {
    window.removeEventListener('scroll', onWindowScrollDebounced);
  };
};

export const handleDropdown = (item, router, setActiveTab = null) => {
  const {value, child, routerPushUrl} = item;
  let newUrl = routerPushUrl;
  if (child) {
    const params = new URLSearchParams();
    params.set('tab', value);
    newUrl = `${router.pathname}?${params.toString()}`;
    setActiveTab(value);
  }
  router.push(newUrl);
};

export const setTabUrl = (activeTab, setActiveTab, router) => {
  if (!window) return;
  const tabParam = new URLSearchParams(window.location.search);
  const getTab = tabParam.get('tab');
  if (getTab) setActiveTab(getTab);
  else {
    tabParam.set('tab', activeTab);
    const newUrl = `${router.pathname}?${tabParam.toString()}`;
    router.push(newUrl);
  }
};
